// reference: https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references
const specialChars = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&apos;',
  "'": '&quot;',
};

/**
 * Takes a string and replaces XML predefined entities if needed
 * @param {string} snippet
 * @returns {string|null}
 */
const replacePredefinedXMLEntities = (snippet) => {
  if (!snippet) {
    return null;
  }

  const cleanSnippet = snippet
    .split('')
    .map((char) => {
      const isCharSpecial = Object.keys(specialChars).includes(char);
      if (isCharSpecial) {
        return specialChars[char];
      }
      return char;
    })
    .join('');

  return cleanSnippet;
};

export default replacePredefinedXMLEntities;
